import get from 'lodash/get';
import { SET_CUSTOM_ERROR } from '../../constants/clz';

export default function customError(state = '', action) {
  if (action.type === SET_CUSTOM_ERROR) {
    return get(action.payload, '0.message') || '';
  }

  return state;
}
